import React, { useState, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars";

const CustomScrollbars = (props: any) => {
  const [scrollbarsId] = useState<string>(`scrollbars-${new Date().getTime()}`);

  // Only if rtl => marginLeft: props.style.marginRight, marginRight: 0
  useEffect(() => {
    let elem = document.getElementById(scrollbarsId);
    if (!elem) return;

    let childs = Array.from(elem.children as HTMLCollectionOf<HTMLElement>);
    childs[0].style.marginLeft = childs[0].style.marginRight;
    childs[0].style.marginRight = "0";
  }, []);

  return (
    <Scrollbars
      id={scrollbarsId}
      {...props}
      autoHide
      renderTrackHorizontal={(rthProps: any) => {
        return (
          <div
            {...rthProps}
            style={{ display: "none" }}
            className="track-horizontal"
          />
        );
      }}
    />
  );
};

export default CustomScrollbars;
